"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_router_1 = require("react-router");
/**
 * Use this component inside a top-level <Route /> handler when you'd like
 * the page to be scrolled to the top after a URL change.
 *
 * This component requires a router.
 *
 * See https://github.com/allenai/varnish/issues/119
 *     https://reacttraining.com/react-router/web/guides/scroll-restoration
 */
var ScrollToTopOnPageChangeImpl = function (_a) {
    var history = _a.history;
    react_1.useEffect(function () {
        return history.listen(function () {
            window.scrollTo(0, 0);
        });
    });
    return null;
};
exports.ScrollToTopOnPageChange = react_router_1.withRouter(ScrollToTopOnPageChangeImpl);
//# sourceMappingURL=ScrollToTopOnPageChange.js.map